import type {Property} from 'csstype';

import {CANVAS_OBJECT_BACKGROUND_TYPES} from '@edume/bento/lessonValidation';

import type {Choice} from './ObjectTypes/Poll/PollObject';

export type CanvasSize = {
  width: number;
  height: number;
};

export const BackgroundTypes = CANVAS_OBJECT_BACKGROUND_TYPES;

export type BackgroundType =
  (typeof BackgroundTypes)[keyof typeof BackgroundTypes];

export const ObjectTypes = {
  Text: 'text',
  Sticker: 'sticker',
  Poll: 'poll',
  StepLink: 'stepLink',
  Emoji: 'emoji',
} as const;

export type ObjectType = (typeof ObjectTypes)[keyof typeof ObjectTypes];

export {CANVAS_OBJECT_TEXT_SIZE_MAP as TEXT_SIZE_MAP} from '@edume/bento/lessonValidation';

type BaseStyles = {
  x?: number;
  y?: number;
  scale?: number;
  rotate?: number;
  width?: number;
  height?: number;
  fontSize?: number;
  textColor?: string;
  textAlign?: Property.TextAlign;
};

export type BaseObject = {
  id: string;
  type: ObjectType | (string & {});
  styles: BaseStyles;
  backgroundType?: BackgroundType;
  text?: string;
  htmlContent?: string;
  url?: string;
  choices?: Choice[];
  order: number;
} & (
  | {
      type: 'sticker';
      styles: BaseStyles & {
        width: number;
        height: number;
      };
    }
  | {
      type: 'text';
      htmlContent: string;
      backgroundType: string;
      backgroundColor: string;
      styles: BaseStyles & {
        fontSize: number;
      };
    }
  | {
      type: 'emoji';
      code?: string;
      backgroundType?: never;
      styles: BaseStyles & {
        fontSize?: never;
      };
    }
  | {
      type: string;
      styles: BaseStyles & {
        width?: number;
        height?: number;
      };
    }
);

export interface CanvasMedia {
  original: string | null;
  url: string | null;
  thumbnail: string | null;
  thumbnailSmall: string | null;
  trim: Trim | null;
  crop: Crop | null;
  mute: boolean | null;
  externalUrl: string | null;
  name: string | null;
  size: number | null;
  uploadPercent: number;
  local: string | null;
  localUri: string | null;
  localSource: string | null;
  localSourceUri: string | null;
}

export interface Trim {
  start: number;
  end: number;
}

export interface Crop {
  x: number;
  y: number;
  width: number;
  height: number;
}

export const ProcessStatuses = {
  Waiting: 'waiting',
  Processed: 'processed',
  Errored: 'errored',
} as const;

export type ProcessStatusType =
  (typeof ProcessStatuses)[keyof typeof ProcessStatuses];

export interface ProcessStatus {
  conf?: {
    trim: Trim;
    crop: Crop;
  };
  status?: ProcessStatusType;
}
